<template>
  <section class="_pt0">
    <app-advanced-table-section
      title="Paid Invoices"
      class="_bt1"
      :loading="paymentHistoryLoading"
      :headers="invoiceHeaders"
      :items="paymentHistory"
      :itemKey="'invoiceNumber'"
      :custom-sort="tableSorter"
    />
  </section>
</template>

<script>
  import billing from '@mixins/billing'
  import AppAdvancedTableSection from '@sections/AdvancedTableSection.vue'
  import tableSorter from '@mixins/tableSorter'

  export default {
    mixins: [billing, tableSorter],
    components: {
      AppAdvancedTableSection
    },
    data() {
      return {
        invoiceHeaders: [
          { text: 'Invoice Number', value: 'invoiceNo' },
          { text: 'Status', value: 'pmtStatus' },
          { text: 'Invoice Date', value: 'invoiceDate' },
          { text: 'Invoice Type', value: 'invoiceDescription' },
          { text: 'Amount Paid', value: 'displayPaidAmount' }
        ]
      }
    }
  }
</script>
